<template>
  <div class="row mb-5">
    <div class="col-12">
      <div class="mb-4 d-flex align-middle">
        <h3>Current Voucher Codes</h3>

        <ExportVoucherCodes
          class="ml-auto"
        />
      </div>

      <table class="table table-hover">
        <thead class="thead-dark">
          <tr>
            <TableH
              label="Voucher Code"
            />
            <TableH
              label="Expiration Date"
              queryKey="expiresAt"
            />
            <TableH
              label="Status"
              queryKey="usedAt"
            />
          </tr>
        </thead>

        <tfoot v-if="isProcessing">
          <tr>
            <td colspan="3">
              <div class="progress">
                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
              </div>
            </td>
          </tr>
        </tfoot>

        <tfoot v-else-if="error">
          <tr>
            <td colspan="3">
              <div
                class="alert alert-danger"
                role="alert"
              >
                {{getRequestError()}}
              </div>
            </td>
          </tr>
        </tfoot>

        <tfoot v-else-if="voucherCodes.length === 0">
          <tr>
            <td colspan="3">
              <div
                class="alert alert-info"
                role="alert"
              >
                You haven't created any Voucher Codes yet.
              </div>
            </td>
          </tr>
        </tfoot>

        <tbody v-else>
          <tr
            v-for="voucherCode in voucherCodes"
            :key="voucherCode.voucherCode"
          >
            <th scope="row">{{voucherCode.voucherCode}}</th>
            <td>{{voucherCode.expiresAt}}</td>
            <td>
              <span
                v-if="voucherCode.hasBeenUsed"
                class="text-success"
              >
                USED
              </span>

              <span
                v-else
                class="text-danger"
              >
                NOT USED
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  import RequestMixin from '@/mixins/RequestMixin'

  import AdminAPI from '@/api/AdminAPI'

  import ExportVoucherCodes from './ExportVoucherCodes'

  import TableH from '@/components/TableH'

  export default {
    mixins: [
      RequestMixin,
    ],

    components: {
      ExportVoucherCodes,
      TableH,
    },

    data() {
      return {
        voucherCodes: [],
      }
    },

    methods: {
      async loadVoacherCodes() {
        const voucherCodes = await AdminAPI.getVoucherCodes(this.$route.query)

        this.voucherCodes = voucherCodes
          .map(voucherCode => {
            const expiresAt = new Date(voucherCode.expiresAt)

            return {
              ...voucherCode,
              expiresAt: moment(expiresAt, 'YYYY-MM-DD').format('YYYY-MM-DD'),
            }
          })
      },

      async loadData() {
        this.handleRequest(this.loadVoacherCodes)
      },
    },

    watch: {
      $route() {
        this.loadData()
      },
    },

    mounted() {
      this.loadData()
    },
  }
</script>

<style lang="scss" scoped>
  table {
    table-layout: fixed;
  }
</style>
